import { Injectable } from '@angular/core';
import posthog, { PostHog } from 'posthog-js';
import { environment } from 'apps/core/src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PosthogService {
  private client: PostHog | null = null;

  init(): void {
    // za sada disabled
    return;

    // if (!environment.production) {
    //   return;
    // }
    //
    // if (this.client) {
    //   return; // prevent double init
    // }
    //
    // posthog.init(environment.posthogKey, {
    //   //api_host: '/ingest',
    //   api_host: 'https://eu.posthog.com',
    //   ui_host: 'https://eu.posthog.com',
    //   capture_exceptions: true,
    //   debug: !environment.production,
    //   defaults: '2025-05-24',
    //   // before_send: (event) => {
    //   //   if (event.event !== 'create_fiskalni') {
    //   //     return null;
    //   //   }
    //   //
    //   //   return event;
    //   // },
    //
    //   loaded: (ph: posthogKey) => {
    //     ph.register({
    //       source: 'product_app',
    //     });
    //   },
    // });
    //
    // this.client = posthog;
  }

  identify(user: {
    id: string;
    email?: string;
    companyId?: string;
    plan?: string;
  }): void {
    if (!this.client) return;

    this.client.identify(user.id, {
      email: user.email,
      company_id: user.companyId,
      plan: user.plan,
    });
  }

  capture(event: string, properties?: Record<string, any>): void {
    if (!this.client) return;
    this.client.capture(event, properties);
  }

  reset(): void {
    this.client?.reset();
  }
}
